export enum Roles {
    Admin = 100,
    User = 0
}
